import React from "react";
import cn from "classnames";
export default function Button(_a) {
    var _b = _a.type, type = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "small" : _c, disabled = _a.disabled, onClick = _a.onClick, onDisabledClick = _a.onDisabledClick, _d = _a.className, className = _d === void 0 ? "" : _d, children = _a.children;
    var classes = cn("button", className, size, type, { disabled: disabled });
    var handleClick = function (event) {
        if (disabled) {
            event.preventDefault();
            if (onDisabledClick)
                onDisabledClick();
        }
        else if (onClick) {
            onClick(event);
        }
    };
    return (React.createElement("button", { className: classes, onClick: handleClick, type: "button" }, children));
}
